export default "__VITE_ASSET__DbKzCMeM__"